import { WHATSAPP_LINK, CONTACT_EMAIL } from "../lib/api";

export function LegalLayout({ doc }) {
  return (
    <article data-testid="legal-page" className="bg-white text-slate-700">
      <header className="bg-brand-obsidian grain relative overflow-hidden">
        <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 md:py-24 lg:px-8">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-orange">
            {doc.eyebrow}
          </p>
          <h1 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
            {doc.title}
          </h1>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-300">
            {doc.intro}
          </p>
        </div>
      </header>

      <div className="mx-auto max-w-4xl px-4 py-14 sm:px-6 md:py-20 lg:px-8">
        <nav
          aria-label="Índice do documento"
          className="mb-12 rounded-2xl border border-slate-200 bg-slate-50 p-6"
        >
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">
            Índice
          </p>
          <ul className="mt-3 grid grid-cols-1 gap-x-6 gap-y-1 sm:grid-cols-2">
            {doc.sections.map((s) => (
              <li key={s.h}>
                <a
                  href={`#${doc.slug}-${s.h.replace(/\./g, "")}`}
                  className="text-sm text-slate-600 transition-colors hover:text-brand-orange"
                >
                  {s.h} · {s.t}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="space-y-12">
          {doc.sections.map((s) => (
            <section key={s.h} id={`${doc.slug}-${s.h.replace(/\./g, "")}`}>
              <h2 className="font-display text-xl font-bold tracking-tight text-slate-900 sm:text-2xl">
                <span className="text-brand-orange">{s.h}.</span> {s.t}
              </h2>
              {s.paras?.map((p, i) => (
                <p key={i} className="mt-4 text-base leading-relaxed text-slate-600">
                  {p}
                </p>
              ))}
              {s.groups?.map((g, i) => (
                <div key={i} className="mt-4">
                  <p className="font-semibold text-slate-900">{g.t}</p>
                  <p className="mt-1 text-base leading-relaxed text-slate-600">{g.d}</p>
                </div>
              ))}
              {s.list && (
                <ul className="mt-4 space-y-2">
                  {s.list.map((li, i) => (
                    <li key={i} className="flex gap-3 text-base leading-relaxed text-slate-600">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-orange" />
                      {li}
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>

        <div className="mt-16 rounded-2xl border border-slate-200 bg-slate-50 p-6 sm:p-8">
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">
            Contato oficial
          </p>
          <p className="mt-2 text-base text-slate-700">
            {CONTACT_EMAIL} · {WHATSAPP_LINK ? <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="font-semibold text-brand-orange hover:underline">WhatsApp de suporte</a> : null}
          </p>
        </div>
      </div>
    </article>
  );
}
